import type { ReactNode } from 'react';
import { Box, Typography } from '@mui/material';

import { DASH } from '../tokens';

export interface DashedNoteProps {
  children: ReactNode;
  icon?: ReactNode;
}

export function DashedNote({ children, icon }: DashedNoteProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        padding: '8px 16px',
        borderRadius: '8px',
        bgcolor: DASH.surface,
        borderStyle: 'dashed',
        borderWidth: '2px',
        borderColor: DASH.rowBorder,
      }}
    >
      {icon}
      <Typography
        component="div"
        sx={{ fontWeight: 500, fontSize: '16px', lineHeight: '24px', color: DASH.lockedText }}
      >
        {children}
      </Typography>
    </Box>
  );
}
